module.exports = __webpack_public_path__ + "static/more_vert.e8d89c7b.svg";